import React from 'react';
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import { MDBContainer, MDBTable, MDBTableBody, MDBTableHead, MDBDataTable, MDBDataTableV5 } from 'mdbreact';
import * as misConstantes from '../../../../js/constantes.js';
import InicioBreadcrumbs from '../../../../pages/template/breadcrumbs/InicioBreadcrumbs.js'

import {
	Switch,
	Route,
	BrowserRouter,
	Link,
	useLocation,
	useParams
} from "react-router-dom";

import axios from "axios";



class ModificacionOrdenesCompra extends React.Component {
	constructor(props) {
	    super(props);

		var url = window.location.href;
		var data = url.split("/");
		var idModificacionOrdenCompra = data[data.length - 1];

 		var columnas = [ 
								
								{ field: "linea", label: "#", attributes: {'width':'10%'} },
								{ field: "descripcion", label: "Descripción", attributes: {'width':'45%'} },
								{ field: "cantidad", label: "Cantidad", attributes: {'width':'15%'} },
								{ field: "precio", label: "Precio", attributes: {'width':'15%'} },
								{ field: "total", label: "Total", attributes: {'width':'15%'} }
 
 						];
	    this.state = {  
	    						datos: {columns: columnas, rows:[]}, columnas: columnas, idModificacionOrdenCompra: idModificacionOrdenCompra,
								aprobaciones: [], modificacionOrdenesCompra: {}, ordenCompra: {}, entidad: {}, lineasCambios: [],
								aprobacionActual: {}, mostrarAprobacionModificacionOrdenCompra: false, respuestaAprobacion: "", verBotonAprobacion: "none"
						};
	}
	componentDidMount() {
		this.cargarModificacionOrdenCompra();
	}
	

	
	
	render(){
		 
	
		 return (
			<>
				<div class="menu" style={{backgroundColor:  "#dbe7fc", width: "100%", padding: "10px", fontSize: "12px" }}>
					<div class="container">
						<InicioBreadcrumbs></InicioBreadcrumbs> / <Link to = {  "/modificaciones-ordenes-compra"  } >Modificaciones ordenes compra</Link> / Modificación orden de compra
					</div>
				</div>
				<div class="container" style={{minHeight: '550px', paddingTop: "30px"}}>
					<div class = 'subitulosPaginaNotificaciones'>
						<b>Modificación orden compra</b>
					</div><br/>
					
							
								<div class="bs-wizard" id = 'aprobaciones' style = {{ textAlign: "center", width: "100%", paddingLeft: "70px" }}>
								
									<div class="row bs-wizard" style={{borderBottom: "0"}}>
				                
						                { this.state.aprobaciones }
						                
						               
						            </div>
								</div>
								
					<br/><br/><br/>
					
					<div class="row">
						
							<div class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12" style={{marginBottom: '20px', display: this.state.verBotonAprobacion }}>
								<Button variant="primary" style = {{width: "100%"}} onClick = { this.handleAbrirMostrarAprobacionModificacionOrdenCompra.bind(this) } >
						        	<i class="fas fa-check"></i> Aprobar cambio
						      	</Button>
							</div>
					</div>
					<br/>
					
					<div class="fila">
						<div class="col-lg-7 col-md-7 col-sm-12 mr-auto" style={{paddingLeft: "10px !important"}} >
							<br/>
							<table class = 'table table-bordered table-hover table-sm table-striped dataTable'>
								<thead>
									<tr>
										<th colSpan = '2'>Datos</th>
									</tr>
								</thead>
								<tbody data-test="table-body">
									<tr>
										<td width = '40%'>Entidad</td>
										<td width = '60%'>{ this.state.entidad.nombre }</td>
									</tr>
									<tr>
										<td>Orden de compra</td>
										<td><a href = ''>{ this.state.ordenCompra.numero }</a></td>
									</tr>
									<tr>
										<td>Fecha orden de compra</td>
										<td>{ this.state.ordenCompra.fecha }</td>
									</tr>
									
								</tbody>
							</table>
						</div>
						<div class="col-lg-5 col-md-5 col-sm-12 mr-auto" style={{paddingLeft: "10px !important"}} >
						</div>
						
						
						<Modal show={ this.state.mostrarAprobacionModificacionOrdenCompra } onHide={  this.handleCloseMostrarAprobacionModificacionOrdenCompra.bind(this)  }>
								 <Modal.Header closeButton>
									 <Modal.Title>Aprobar modificación</Modal.Title>
								 </Modal.Header>
								 <Modal.Body>
									<input type = 'hidden' value = {this.state.idEliminarArchivoProveedorProcesoSimulacion}/>
									¿Seguro quiere aprobar la modificación de orden de compra?<br/>
									{this.state.respuestaAprobacion}
								 </Modal.Body>
								 <Modal.Footer>
									<Button variant="secondary" onClick = { this.handleCloseMostrarAprobacionModificacionOrdenCompra.bind(this) } >Cerrar</Button>
			   						<Button variant="success" onClick = { this.aprobarModificacionOrdenCompra.bind( this ) } >Aprobar</Button>
								 </Modal.Footer>
							 </Modal>
					</div>
					<br/><br/>
					
					<MDBDataTable striped bordered  small data={ this.state.datos } hover entriesOptions={[5, 10, 15, 25]} entries={15} pagesAmount={4} condensed/>
					<br/><br/>
				
				
				{ /**
				// ------------------------------------------------------------------------------------------------------
				// Cotizacion
				// ------------------------------------------------------------------------------------------------------
				 */}
				
					 
				</div>
			
			</>
			
		)
	}
	
	

	// ----------------------------------------
	// Cargar Cotizacion
	// ----------------------------------------
	handleCloseMostrarAprobacionModificacionOrdenCompra(){
		this.setState( {mostrarAprobacionModificacionOrdenCompra: false} );
	}
	handleAbrirMostrarAprobacionModificacionOrdenCompra(){
		this.setState( {mostrarAprobacionModificacionOrdenCompra: true} );
	}
	// ----------------------------------------
	// Cargar Cotizacion
	// ----------------------------------------
	cargarModificacionOrdenCompra(){
		var anchoPantalla = document.getElementById("aprobaciones").offsetWidth;
//		alert( anchoPantalla + "px" );
		
		var codigo = localStorage.getItem('simuladores.proveedores.codigoUsuario' );
		var idModificacionOrdenCompra = this.state.idModificacionOrdenCompra;
		
		var info = { "codigo": codigo, "idModificacionOrdenCompra":idModificacionOrdenCompra };
		axios.post( misConstantes.URL_CONSULTA + '/ServletModificacionOrdenCompra', info, {params: info}).then(function (response) {
			var modificacionOrdenesCompra = response.data;
			var aprobaciones = modificacionOrdenesCompra.aprobaciones;
			var definitivo = [];
			var lineasCambios = modificacionOrdenesCompra.lineasModificacionesOrdenesCompra;
			var aprobacionActual = modificacionOrdenesCompra.aprobacionActual;
			
			if(  aprobacionActual.usuario == "Proveedor TVEC" ){
				this.setState({ verBotonAprobacion: "initial" });
			}else{
				this.setState({ verBotonAprobacion: "none" });
			}
			
//			alert(  JSON.stringify( aprobacionActual ) );
			
			var anchoDiv  = (anchoPantalla - 100)/(aprobaciones.length+1);
			
//			alert( JSON.stringify(  aprobacionActual ) );
			
			for( var i = 0 ; i < aprobaciones.length; i++ ){
//				alert( JSON.stringify(  aprobaciones[i] ) );
//				var html = <></>;
				if( i == 0 ){
					var html = <>
									<div class="col-xs-3 bs-wizard-step complete"  style = {{width: anchoDiv + "px"}}>
						                  <div class="text-center bs-wizard-stepnum" style = { { "font-size": "9px" } }>{ aprobaciones[i].usuario }</div>
						                  <div class="progress"><div class="progress-bar"></div></div>
						                  <a href="#" class="bs-wizard-dot"></a>
						                </div>
							</>;
					definitivo.push( html );
				}else if(  i == aprobaciones.length-1 ){
					
					var html = <>
									 <div class="col-xs-3 bs-wizard-step active" style = {{width: anchoDiv + "px"}}>
						                  <div class="text-center bs-wizard-stepnum" style = { { "font-size": "9px" } }>{ aprobaciones[i].usuario }</div>
						                  <div class="progress"><div class="progress-bar"></div></div>
						                  <a href="#" class="bs-wizard-dot"></a>

										  {/**
											<div class="progress"><div class="progress-bar"></div></div>
						                  	<a href="#" class="bs-wizard-dot"></a>  
											*/}
						                </div>
							</>;
					definitivo.push( html );
					
				}else{
					
					var html = <>
								<div class="col-xs-3 bs-wizard-step complete"  style = {{width: anchoDiv + "px"}}>
						                  <div class="text-center bs-wizard-stepnum" style = { { "font-size": "9px" } }>{ aprobaciones[i].usuario }</div>
						                  <div class="progress"><div class="progress-bar"></div></div>
						                  <a href="#" class="bs-wizard-dot"></a>
						                   {/** <div class="bs-wizard-info text-center">Lorem ipsum dolor sit amet.</div> */}
						                </div>
								</>;
					definitivo.push( html );
					
					
				}
				
				
			}
			
			
			html = <>
								<div class="col-xs-3 bs-wizard-step"  style = {{width: anchoDiv + "px"}}>
						                  <div class="text-center bs-wizard-stepnum" style = { { "font-size": "9px" } }>Finalización</div>
						                  <div class="progress"><div class="progress-bar"></div></div>
						                  <a href="#" class="bs-wizard-dot"></a>
						                   {/** <div class="bs-wizard-info text-center">Lorem ipsum dolor sit amet.</div> */}
						                </div>
								</>;
					definitivo.push( html );
			
			this.setState( {aprobaciones: definitivo, modificacionOrdenesCompra:modificacionOrdenesCompra, aprobacionActual: aprobacionActual } );
			
			
			
			this.cargarOrdenCompra(modificacionOrdenesCompra.numeroOrdenCompra);
		}.bind(this)).catch(function (error) {
		});
	}
	cargarOrdenCompra(numeroOrdenCompra){
		var codigo = localStorage.getItem('simuladores.proveedores.codigoUsuario' );
		var info = { "codigo": codigo, "numeroOrdenCompra":numeroOrdenCompra };
		
		
		
		axios.post( misConstantes.URL_CONSULTA + '/ServletOrdenCompra', info, {params: info}).then(function (response) {
			
//			alert( JSON.stringify( response.data ) );
			
			var ordenCompra = response.data;
			var lineas = ordenCompra.lineasOrdenCompra;
			var entidad = ordenCompra.entidad;
			var columns = this.state.columnas;
			var rows = [];
			
			for( var i = 0; i < lineas.length; i++ ){
				
				var linea  =   lineas[i].indice;
				var descripcion  =   lineas[i].descripcion;
				var cantidad  =   lineas[i].scantidad;
				var precio  =   lineas[i].sprecio;
				var total  =   lineas[i].stotal;
				
				
				var row = {
							linea: linea,
							descripcion: descripcion,
							cantidad: cantidad,
							precio: precio,
							total: total
						}
				rows.push(row);
			}

			var datos = {columns: columns, rows: rows}
			this.setState({datos: datos, ordenCompra: ordenCompra, entidad: entidad});
			
			
		}.bind(this)).catch(function (error) {
		});
		
	}
//	72606
	
	aprobarModificacionOrdenCompra(){
		var aprobacionActual = this.state.aprobacionActual;
		var codigo = localStorage.getItem('simuladores.proveedores.codigoUsuario' );
		var info = { "codigo": codigo, "idAprobacion":aprobacionActual.id };
		this.setState( { respuestaAprobacion: "Cargando" } );
		axios.post( misConstantes.URL_CONSULTA + '/ServletAprobarModificacionOrdenCompra', info, {params: info}).then(function (response) {
			var respuesta = response.data;
			this.setState( { respuestaAprobacion: respuesta.mensaje } );
			if( respuesta.respuesta == "exito" ){
				this.setState( {  mostrarAprobacionModificacionOrdenCompra: false  }  );
				this.cargarModificacionOrdenCompra();
			}
			
		}.bind(this)).catch(function (error) {
		});
	}
}

export default ModificacionOrdenesCompra;
